<template>
  <div class="service-question-page">
    <div class="head">
      <!--   时间选择   -->
      <timeSelect class="time-select" @screen="screen"></timeSelect>
      <!--  城市选择  -->
      <citySelect serviceProvider="2" @chioce="chioceCity"></citySelect>
    </div>

    <!--    环形图    -->
    <pieChart :resultList="arrCirceList" @circeClick="circeClick"></pieChart>

    <!--    特殊线    -->
    <div class="liner-de"></div>
    <!--     数据列表     -->
    <div class="rank-list-wrap">
      <!--      切换栏      -->
      <div class="switch-content">
        <!-- <div class="switch-title">常见问题</div> -->
        <div @click="changeVisible" class="switch-entity">
          <p>常见问题-{{ sActiveSwitchName }}</p>
          <img class="icon" :src="require('@/assets/images/result/down_icon_co.png')" alt="" />
        </div>
      </div>
      <!-- 模块 -->
      <div class="modular">
        <div class="modular-wrap">
          <div class="modular-content">
            <div
              class="modular-item"
              v-for="(item, index) in arrModularList"
              :key="index"
              :class="{ 'modular-item-active': item.active }"
              @click="choseModular(item.id)"
            >
              {{ item.new_name}} {{item.num}}
            </div>
          </div>
        </div>
      </div>
      <!-- 文字详情 -->
      <div class="text-question">
        <div class="content">
          <span>错误问题</span>
          <span>问题数</span>
        </div>
      </div>
      <!--      内容      -->
      <div class="entity-content">
        <div class="entity-item" v-for="item in arrQuestionRankList" :key="item.title" @click="goToQuestionDes(item.id)">
          <p class="context">{{ item.name }}</p>
          <p class="num">{{ item.nums }}</p>
          <img class="icon" :src="require('@/assets/images/service/customerscoring/service-to-right-icon.png')" alt="" />
        </div>
      </div>
    </div>
    <!--    选择弹窗    -->
    <VantPopup position="bottom" round v-model="bSelectVisible">
      <VantPicker show-toolbar @cancel="changeVisible" @confirm="switchActive" :columns="arrSwitchList" value-key="name"></VantPicker>
    </VantPopup>
  </div>
</template>

<script>
import timeSelect from "@/components/timeSelect/index";
import citySelect from "@/page/service/components/cityselect";
import pieChart from "@/page/service/components/piechart";
import { mapState } from "vuex";
import { Popup, Picker } from "vant";
import { getQuestionCirce, getQuestionType, getQuestionModular, getQuestionList } from "@/js/service";
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';

export default {
  name: "index",
  components: {
    timeSelect,
    citySelect,
    pieChart,
    VantPopup: Popup,
    VantPicker: Picker,
  },
  data() {
    return {
        nQuestionHighId:'',
      nAreaId: "", //城市id
      nProviderId:"",//服务商下拉ID
      nCityId:"",//城市下拉id
      nOrderId: "",
      sStartTime: "开始时间", //开始时间
      sEndTime: "结束时间", //结束时间
      nWidth: 2000,
      //问题模块内容
      arrModularList: [],
      //环形图数据
      arrCirceList: [],
      // 切换栏数据列表
      arrSwitchList: [],
      // 激活的数据栏ID
      sActiveSwitchName: "",
      // 选择器显示控制
      bSelectVisible: false,
      // 问题列表分页
      page: {
        page: 0,
        limit: 10000,
      },
    };
  },
  mounted() {
        fetchVerifyAuthForB(()=>{
        this.$store.commit("loadSwitch", true);
       // this.getCirceData()

    })

    // $init(() => {
    //   this.$store.commit("loadSwitch", true);
    //   Promise.all([this.getCirceData()]).then((res) => {});
    // });
  },
  computed: {
    ...mapState({
      // 高频问题
      arrQuestionRankList: (state) => state.serviceCustomerScoring.arrQuestionRankList,
    }),
  },
  methods: {
    chioceCity(e) {
        // 判断是否是清除
        if(e.sClearType){
            if(e.sClearType=='DQ'){
                this.nProviderId=''
                this.nCityId=''
                this.nAreaId=''
            }else if(e.sClearType=='BSC'){
                this.nProviderId=''
                if(e.clearCity){
                    this.nCityId=''
                }
            }else if(e.sClearType=='CS'){
                this.nCityId=''
                if(e.clearSrevice){
                    this.nProviderId=''
                }
            }
            this.getCirceData(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nAreaId,this.nProviderId,this.nCityId);
            return
        }
      if(e.third_uuid){
          this.nProviderId=e.third_uuid
           this.getCirceData(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nAreaId,this.nProviderId,this.nCityId);
      }else if(e.id){
        this.nCityId=e.id
          if(e.isClearCompany){
              this.nProviderId=''
          }
             this.getCirceData(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nAreaId,this.nProviderId,this.nCityId);
      }else{
        this.nAreaId=e
          this.nProviderId=''
          this.nCityId=''
            this.getCirceData(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nAreaId,this.nProviderId,this.nCityId);
      }

    },
    //   点击问题跳转
    goToQuestionDes(id) {
      //   将验收内容id保存到vuex
            let editQuestionId =  this.$store.state.questionId
      this.$router.push({path: this.$route.path, query: {questionTypeId:editQuestionId}})//在当前的路由地址更新目前的问题类型id,用于返回该页面显示该问题类型的数据
      this.$store.commit("editServiceId", id);
      this.$router.push({ path: "/service/higtproblems/proxytop" });
    },
    /**
     * 切换栏
     * @param id
     */
    switchActive(e) {
      this.sActiveSwitchName = e.name;
      this.changeVisible();
      // 切换问题类型,获取模块
      this.getQuestionMoulderList(e.id);
        // 保存选择的的问题类型id
      this.$store.commit("editQuestionId", e.id);
    },
    /**
     * 改变弹窗显示
     */
    changeVisible() {
      this.bSelectVisible = !this.bSelectVisible;
    },
    // 获取问题环形图数据
    getCirceData(startTime, endTime, areaId,providerId,cityId) {
      getQuestionCirce({ start_time: startTime, end_time: endTime, area_id: areaId,office_id:providerId,city_id:cityId }).then((res) => {
        this.getQuestionList()//获取下拉数据
        this.$store.commit("loadSwitch", false);
        if(  res.data.data.result.length>0){
            let newArr = [];
          res.data.data.result.forEach((item, index) => {
            let obj = {};
            obj.name = item.name;
            obj.id = item.id;
            obj.value = item.num;
            obj.key = "";
            newArr.push(obj);
          });
          this.arrCirceList = newArr
        //   存储问题最多的类型id
        this.nQuestionHighId=this.arrCirceList[0].id
        }else{
              this.arrCirceList=[]
        }

      });
    },
    // 选择时间
    screen(e) {
      // console.log(e);
      this.nOrderId = e.nOrderId;
      this.sStartTime = e.sStartTime;
      this.sEndTime = e.sEndTime;

      this.getCirceData(e.sStartTime === "开始时间" ? "" : e.sStartTime+" 00:00:00", e.sEndTime === "结束时间" ? "" : e.sEndTime+" 23:59:59", this.nAreaId,this.nProviderId,this.nCityId);
    },
    // 获取问题类型
    getQuestionList() {
      getQuestionType({company_id:this.nProviderId}).then((res) => {
        // 查询问题数最高的，排在第一个
        let items=null
        let indexs=0
        res.data.data.result.forEach((item,index)=>{
            if(this.nQuestionHighId==item.id){
               items=item
               indexs=index
            }
        })
          if(items!=null){
              res.data.data.result.splice(indexs,1)
              res.data.data.result.unshift(items)
          }
        this.arrSwitchList = res.data.data.result;
        //   获取从首页柱形图跳转传来的id
        let questionTypeId = this.$route.query.questionTypeId;
        if (questionTypeId) {
          // 如果是从柱形图跳转过来的
        //   console.log("循环类型找出点击的", this.arrSwitchList);
          this.arrSwitchList.forEach((item) => {
            if (item.id == questionTypeId) {
                 this.$store.commit("editQuestionId",questionTypeId);
              this.getQuestionMoulderList(questionTypeId);
              this.sActiveSwitchName = item.name;
            }
          });
        } else {
          // 默认展示第一个问题类型的数据
          this.sActiveSwitchName = this.arrSwitchList[0].name;
          this.getQuestionMoulderList(this.arrSwitchList[0].id);
          // 保存默认的问题类型id
        this.$store.commit("editQuestionId",this.arrSwitchList[0].id);
        }

      });
    },

    // 根据问题类型获取问题模块
    getQuestionMoulderList(id) {
      getQuestionModular({ project_id: id ,start_time:this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", end_time:this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59",company_id:this.nProviderId,area_id:this.nAreaId,city_id:this.nCityId}).then((res) => {
        if (res.data.data.result.length > 0){
                    // console.log("问题模块", res.data.data.result);
              this.arrModularList = res.data.data.result;
              // 设置第一个模块为选中状态
              this.arrModularList[0].active = true;
              // 默认展示第一个模块的问题列表
              this.getQuestionInfo(res.data.data.result[0].id);
              // 将默认的验收子类id保存到vuex
              this.$store.commit("editProcessId", res.data.data.result[0].id);
        }else{
            // 当选择问题类型没有问题模块就不需要请求问题列表的接口
           this.$store.commit("editQuestionList",[]);
            this.arrModularList=[]
        }

      });
    },
    // 根据问题模块获取问题列表
    getQuestionInfo(id) {
      getQuestionList({
        process_id: id, area_id:this.nAreaId,city_id:this.nCityId,
        ...this.page,
        company_id:this.nProviderId,
        start_time:this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", end_time:this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59"
      }).then((res) => {
        // console.log("问题列表", res.data.data.result);
        this.$store.commit("editQuestionList", res.data.data.result);
      });
    },
    // 选中不同的模块渲染不同的数据
    choseModular(id) {
      // 将选择的的验收子类id保存到vuex
      this.$store.commit("editProcessId", id);
      // 设置激活节点
      let arr = JSON.parse(JSON.stringify(this.arrModularList));
      arr.forEach((item) => {
        if (item.id === id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.arrModularList = arr;
      // 根据id获取不同的问题列表
      this.getQuestionInfo(id);
    },
    // 点击扇形图,回去相关问题类型
    circeClick(e) {
      // console.log(e);
      if(e.name!='其他'){
          this.sActiveSwitchName = e.name;
      }else{
        this.arrSwitchList.forEach(item=>{
            if(item.id==e.id){
               this.sActiveSwitchName = item.name;
            }
        })
      }

      // 保存选择的的问题类型id
                this.$store.commit("editQuestionId",e.id);
         this.getQuestionMoulderList(e.id);
    },
  },
};
</script>

<style scoped lang="scss">
.service-question-page {
  padding: 32px 0;
  background: #ffffff;
  border-radius: $commonRadius;
  margin-bottom: 28px;

  .head {
    padding: 0 24px 30px;

    .time-select {
      margin-bottom: 28px;
    }
  }

  .liner-de {
    height: 2px;
    padding-top: 20px;
    background: linear-gradient(to right, #f1f1f1 50%, transparent 50%) repeat-x left bottom / 16px 2px;
  }

  .rank-list-wrap {
    margin-top: 24px;

    .switch-content {
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: $smallSize;
      margin-bottom: 8px;

      // .switch-title {
      //     line-height: 40px;
      //     color: $deepGreen;
      //     font-weight: 500;
      //     font-size: $baseSize;
      // }

      .switch-entity {
        display: flex;
        width: 100%;
        align-items: center;
        padding: 16px 24px;
        border-radius: $commonRadius;
        border: 2px solid #318544;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 28px;
          font-weight: 500;
          color: #318544;
          font-size: $smallSize;
          letter-spacing: 1px;
        }

        .icon {
          width: 20px;
          height: 20px;
          margin-left: 22px;
        }
      }
    }
    .modular {
      margin-top: 24px;
      padding: 0 24px;
      width: 100%;
      overflow: hidden;
      .modular-wrap {
        // overflow-x: scroll;
        .modular-content {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
          .modular-item {
            // width: 210px;
            border-radius: 4px;
            border: 2px solid #e4e4e4;
            font-size: 24px;
            font-weight: 400;
            color: #858585;
            line-height: 56px;
            text-align: center;
            padding: 0 24px;
            margin-right: 10px;
            margin-bottom: 10px;
          }
          .modular-item-active {
            background: #318544;
            color: #ffffff;
          }
        }
      }
    }
    .text-question {
      padding: 40px 24px 0px 24px;
      font-size: 28px;
      font-weight: 400;
      color: #ff8b5b;
      line-height: 32px;
      .content {
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
      }
    }

    .entity-content {
      padding: 0 24px;

      .entity-item {
        padding: 30px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: $baseSize;
        color: $commonText;
        background: linear-gradient(to right, #f1f1f1 50%, transparent 50%) repeat-x left bottom / 16px 2px;

        .context {
          line-height: 40px;
          flex: 1;
          padding-right: 42px;
        }

        .num {
          felx: 0;
          width: 86px;
          text-align: center;
          color: #858585;
        }

        .icon {
          width: 20px;
          height: 20px;
          flex: 0;
        }
      }
    }
  }
}
</style>
